import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";

export const createRelation = createAsyncThunk(
  "Relation/createRelation",
  async (relationData, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.post(
        "/v1/admin/relation/create-relation",
        relationData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getRelation = createAsyncThunk(
  "Relation/getRelation",
  async (
    {
      id,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstanceJson.get(
        "/v1/admin/relation/get-relation",
        {
          params: {
            id,
            status,
            search,
            page,
            limit,
            startDate,
            endDate,
            paginate,
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const updateRelation = createAsyncThunk(
  "Relation/updateRelation",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.put(
        `/v1/admin/relation/update-relation/${id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteRelation = createAsyncThunk(
  "Relation/deleteRelation",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/relation/delete-relation/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteRelation = createAsyncThunk(
  "Relation/undoDeleteRelation",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/relation/undodelete-relation/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getRelationById = createAsyncThunk(
  "Relation/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/relation/getSingle-relation/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
